import { Model } from 'vue-mc'

class Country extends Model {
  defaults () {
    return {}
  }
}

export default Country
